import {ACTION_TYPES, LOCAL_STORAGE_KEYS} from "../../consts";
import {AppController} from "../../app/app-controller";
import {AbTestingUtils} from "../../../infrastructure/utils/ab-testing-utils";
import {BETTING_PROMOTION} from "../../../apps/website/modules/betting-promotion.module/bettin-ptomotion.module.consts";
import {DeviceViewModel} from "../../models/device.view-model";
import {RemoteConfigManager} from "../../../third-party-services/remote-config/remote-config-manager";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {BettingPromotionLocalStorageModel} from "../../models/betting-promotion/betting-promotion.local-storage.model";
import {BettingPromotionBaseHandler} from "./betting-promotion.base.handler";

export class BettingPromotionInitHandler extends BettingPromotionBaseHandler {
  type = ACTION_TYPES.bettingPromotionInit;
  abTestingManager: AbTestingUtils;
  localStorageUtils: LocalStorageUtils;
  device: DeviceViewModel;
  remoteConfigManager: RemoteConfigManager;

  static injectables = [...BettingPromotionBaseHandler.injectables, AbTestingUtils, DeviceViewModel, RemoteConfigManager];

  constructor(localStorageUtils: LocalStorageUtils, abTestingManager: AbTestingUtils, device: DeviceViewModel, remoteConfigManager: RemoteConfigManager) {
    super(localStorageUtils);

    this.abTestingManager = abTestingManager;
    this.device = device;
    this.remoteConfigManager = remoteConfigManager;
  }

  onInitialized(controller: AppController) {
    super.onInitialized(controller);

    this.controller.action(ACTION_TYPES.bettingPromotionCampaignLink, {utmId: this.utmId});
    this.remoteConfigManager.registerToInitCallback(() => {
      this.getLocalStorage();
      this.action()
    });
  }


  getLocalStorage(): void {
    const bettingPromotionObject: Object = this.localStorageUtils.getJSON(LOCAL_STORAGE_KEYS.bettingPromotion);
    this.model.localStorageModel = new BettingPromotionLocalStorageModel(bettingPromotionObject);

    if (this.model.isDateExpired && (this.model.localStorageModel.clickType !== BETTING_PROMOTION.CLICK_TYPE.notInterested)) {
      this.model.localStorageModel = new BettingPromotionLocalStorageModel();
    }
    this.model.localStorageModel.incrementSession();

    this.updateLocalStorageModel();
  }

  async action() {
    const {mobileType, desktopType} = this.model.remoteConfigModel;

    this.model.localStorageModel.type = this.abTestingManager.getABTestingValue(
      this.device.isSmallView ? mobileType : desktopType,
      BETTING_PROMOTION.TYPES
    );

    this.localStorageUtils.setJSON(LOCAL_STORAGE_KEYS.bettingPromotion, this.model.localStorageModel);
    await this.controller.action(ACTION_TYPES.bettingPromotionPopulate, {utmId: this.utmId});
  }

  get utmId(): String {
    const currentUrl: URL = new URL(window.location.href);
    const utmId: String = currentUrl.searchParams.get(BETTING_PROMOTION.UTM_ID_PARAM) || null;

    return utmId;
  }
}
